import { onUnmounted } from 'vue'
import { LIVE_MESSAGE_KPI_IDS } from '../config/slots'
import messageHub from '@/message/messageHub'
import Actions from '@/message/action'

const LIVE_MESSAGE_KPI_MAP = {
  [Actions.APPLY_JOB]: 1006,
  [Actions.SPECIAL_JOB]: 1016,
  [Actions.HAZARD_LIVE_MESSAGE]: 1007
}

export function useDashboardEvents({ updateRiskLevel, updateLiveMessage, findChartSlotByKpiId }) {
  const disposers = []

  function register(action, handler) {
    disposers.push(messageHub.onEvent(action, (payload = {}) => handler(payload?.data ?? payload)))
  }

  register(Actions.RISK_UPDATE, (levels) => updateRiskLevel(levels ?? []))

  Object.entries(LIVE_MESSAGE_KPI_MAP).forEach(([action, kpiId]) => {
    register(action, (data) => {
      const slotKey = findChartSlotByKpiId(kpiId)
      if (slotKey) updateLiveMessage(slotKey, data ?? [])
    })
  })

  onUnmounted(() => disposers.forEach((dispose) => dispose?.()))

  return { LIVE_MESSAGE_KPI_IDS }
}
